import { BaseApi } from './BaseApi';
import { Dictionary, DKKPriceItem } from 'typings/repo';

const DK_PRICE_API_URL = '/api/order/prices';
const BATCH_SIZE = 20;

export class PriceApi
{
    private httpClient: BaseApi;

    constructor(httpClient: BaseApi)
    {
        this.httpClient = httpClient;
    }

    public getDKKPrices(skus: string[]): Promise<Dictionary<DKKPriceItem>>
    {
        const batches: string[][] = [];
        for (let i = 0; i < skus.length; i += BATCH_SIZE) {
            batches.push(skus.slice(i, i + BATCH_SIZE));
        }

        return Promise.all(
            batches.map(batch => {
                const params = new URLSearchParams();
                batch.forEach(sku => params.append('skus', sku));
                return this.httpClient.httpGet(`${DK_PRICE_API_URL}?${params.toString()}`);
            })
        ).then(results =>
            results.reduce<Dictionary<DKKPriceItem>>((acc, batch) => ({ ...acc, ...batch }), {})
        );
    }
}
